import { LocalDate } from '@js-joda/core';

import {
   PatientPregnantCreateCommand,
   PregnancyCompletionDateBasis,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { FormContextValues } from '@dreryk/react-common';
import { ButtonVariant, ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { gynecologicalInterviewTranslationKeys } from '../../translations';

type GynecologicalInterviewPatientPregnantSubmitValues = {
   predictedCompletionDate: LocalDate | null;
   predictedCompletionDateBasis: PregnancyCompletionDateBasis | null;
   multiplePregnancy: boolean;
   pregnancyConfirmed: boolean;
   description: string | null;
};

type GynecologicalInterviewPatientPregnantCreateActionProps = {
   readonly handleSubmit: FormContextValues<GynecologicalInterviewPatientPregnantSubmitValues>['handleSubmit'];
   readonly medicalInformationId: number;
   readonly patientId: number;
   readonly onSuccess: VoidFunction;
   readonly registerMedicalEvent: boolean;
};

export const GynecologicalInterviewPatientPregnantCreateAction = (
   props: GynecologicalInterviewPatientPregnantCreateActionProps
): JSX.Element => {
   const { executeAsync: createPatientPregnant } = useCqrsCommand<
      void,
      GynecologicalInterviewPatientPregnantSubmitValues
   >(
      (parameters) => {
         const command = new PatientPregnantCreateCommand();
         command.patientId = props.patientId;
         command.multiplePregnancy = parameters.multiplePregnancy;
         command.pregnancyConfirmed = parameters.pregnancyConfirmed;
         command.description = Choice.withUseDefaultIfNull(parameters.description ?? null);
         command.predictedCompletionDate = Choice.withUseDefaultIfNull(parameters.predictedCompletionDate ?? null);
         command.predictedCompletionBasis = Choice.withUseDefaultIfNull(
            parameters.predictedCompletionDateBasis ?? null
         );
         command.medicalInformationId = props.medicalInformationId;
         command.registerMedicalEvent = props.registerMedicalEvent;
         return command;
      },
      {
         onSuccess: props.onSuccess,
      }
   );

   return (
      <ModalConfirmButton
         testId={props.registerMedicalEvent ? 'createPatientPregnantAndSendToP1' : 'createPatientPregnant'}
         label={
            props.registerMedicalEvent
               ? gynecologicalInterviewTranslationKeys.addEntryAndSendToP1
               : gynecologicalInterviewTranslationKeys.addEntry
         }
         onClick={props.handleSubmit(createPatientPregnant)}
         variant={props.registerMedicalEvent ? ButtonVariant.SECONDARY : ButtonVariant.PRIMARY}
      />
   );
};
